import deleteDocument from "./deleteDocument";

const documentServices = {
  deleteDocument,
};

export default documentServices;
